import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

export const Wrapper = styled.div`
  flex-grow: 1;

  ${({ theme }) => media.sm`
    padding-left: ${theme.space.mobile.small};
  `}
`
